import { Box } from '@mui/material';
import styled from 'styled-components';

export const StepContainer = styled(Box)``;
